




import {Component, Prop, Vue} from "vue-property-decorator";
import {IdMapper} from "@/interfaces/state/base";
import {LadingStatus, ReportDeliveryStatus} from "@/enums/status";

@Component({
    name: "ReportDeliveryStatusLabel"
})
export default class extends Vue {
    @Prop({required: true})
    readonly status!: number;
    ReportDeliveryStatus = ReportDeliveryStatus;
    colorMap: IdMapper<string> = {
        [ReportDeliveryStatus.PHAT_THANH_CONG]: 'green',
        [ReportDeliveryStatus.DON_HANG_SU_CO]: 'red',
        [ReportDeliveryStatus.CHUYEN_HOAN]: 'yellow',
        [ReportDeliveryStatus.HOAN_THANH_CONG]: 'blue',
        [ReportDeliveryStatus.PHAT_LAI]: "yellow"
    }
}
